import { useState } from "react"
import { createPortal } from "react-dom"

import CreditsUpgradeModal from "./index"
import { CreditsUpgradeTracking, trackCreditsUpgradeClick } from "./tracking"

interface Props {
  cta: string
  className?: string
  track?: CreditsUpgradeTracking
  user: {
    subscriptionPaymentType: string
    tier: string
  }
}

// Mounts an "Upgrade for more credits" CTA from ERB. Reloads after an upgrade so the
// server-rendered plan and usage pick up the new allowance.
const CreditsUpgradeButton = ({ cta, className, track, user }: Props) => {
  const [showModal, setShowModal] = useState(false)

  const openModal = () => {
    if (track) trackCreditsUpgradeClick(track, user.tier)
    setShowModal(true)
  }

  return (
    <>
      <button type="button" className={className} onClick={openModal}>
        {cta}
      </button>
      {createPortal(
        <CreditsUpgradeModal
          onClose={() => setShowModal(false)}
          onUpgraded={() => window.location.reload()}
          track={track}
          user={user}
          visible={showModal}
        />,
        document.body,
      )}
    </>
  )
}

export default CreditsUpgradeButton
